import { motion } from 'framer-motion'
import { Helmet } from 'react-helmet-async'
import Technologies from '../components/Technologies'

export default function TechnologiesPage() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <Helmet>
        <title>Technologies | Ionic Errrrs Code</title>
        <meta name="description" content="Explore the modern technologies and frameworks used by Ionic Errrrs Code — React, Flutter, Node.js, and more." />
        <link rel="canonical" href="https://ionicerrrrscode.com/technologies" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Ionic Errrrs Code" />
        <meta property="og:title" content="Technologies | Ionic Errrrs Code" />
        <meta property="og:description" content="Explore the modern technologies and frameworks used by Ionic Errrrs Code — React, Flutter, Node.js, and more." />
        <meta property="og:url" content="https://ionicerrrrscode.com/technologies" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Technologies | Ionic Errrrs Code" />
        <meta name="twitter:description" content="Explore the modern technologies and frameworks used by Ionic Errrrs Code — React, Flutter, Node.js, and more." />
      </Helmet>
      <Technologies />
    </motion.div>
  )
}
